/**
 * Функция для проверки принадлежности значения к enum
 *
 * @param value - Проверяемое значение
 * @param enumObject - Объект перечисления
 * @returns true если значение является значением enum
 *
 * @example
 * isValueInEnum('RED', Color) // true
 */
export const isValueInEnum = <T extends object>(
    value: unknown,
    enumObject: T
): value is T[keyof T] => Object.values(enumObject).includes(value as T[keyof T]);